
import { createServiceClient } from "shared/welda/services/axiosClient";

const apiSQL = createServiceClient("/sql");

const monthSalesInfo = async (params) =>
  await apiSQL.get("/monthSalesInfo", {
    params,
  });

const historiekKlantArt = async (params) =>
  await apiSQL.post("/historiekKlantArt", params);

const handleTags = async (params) => await apiSQL.post("/handleTags", params);

const updateLopendeLVB = async () => await apiSQL.get("/updateLopendeLVB");

const updateLopendeVKO = async () => await apiSQL.get("/updateLopendeVKO");

/** Full sync, or one HRB when doknr + dossiernr are passed. */
const updateLopendeHRB = async ({ doknr, dossiernr } = {}) =>
  await apiSQL.get("/updateLopendeHRB", {
    params: {
      ...(doknr != null && doknr !== "" ? { doknr } : {}),
      ...(dossiernr != null && dossiernr !== "" ? { dossiernr } : {}),
    },
  });

const LopendeVKO = async () => await apiSQL.get("/LopendeVKO");

const LopendeHRB = async () => await apiSQL.get("/LopendeHRB");

const Paymentsdata = async () => await apiSQL.get("/Paymentsdata");

const LopendeLVB = async () => await apiSQL.get("/LopendeLVB");

const LopendeMOF = async () => await apiSQL.get("/LopendeMOF");

const LopendeHRF = async () => await apiSQL.get("/LopendeHRF");

const OpenstaandeDoc = async () => await apiSQL.get("/OpenstaandeDoc");

const OpenstaandeDocSuppliers = async () =>
  await apiSQL.get("/OpenstaandeDocSuppliers");

const AllFinanceDocsCustomers = async () =>
  await apiSQL.get("/AllFinanceDocsCustomers");

const AllFinanceDocsSuppliers = async () =>
  await apiSQL.get("/AllFinanceDocsSuppliers");

const updateOpenstaandeDoc = async () =>
  await apiSQL.get("/updateOpenstaandeDoc");

const updateOpenstaandeDocSuppliers = async () =>
  await apiSQL.get("/updateOpenstaandeDocSuppliers");

const updateAllFinanceDocsCustomers = async () =>
  await apiSQL.get("/updateAllFinanceDocsCustomers");

const updateAllFinanceDocsSuppliers = async () =>
  await apiSQL.get("/updateAllFinanceDocsSuppliers");

const GetSalesData = async (params) =>
  await apiSQL.get("/GetSalesData", {
    params,
  });

const getMarginByMerkPerVert = async (params) =>
  await apiSQL.get("/GetMarginByMerkPerVert", {
    params,
  });

const updateSalesData = async (params) =>
  await apiSQL.get("/updateSalesData", {
    params,
  });

const AddManualTag = async (params) =>
  await apiSQL.post("/salesData/addManualTag", params);

const MOFdata = async () => await apiSQL.get("/MOFdata");

const GetOrdersByCustomer = async (params) =>
  await apiSQL.get("/GetOrdersByCustomer", {
    params: params,
  });

const SalesInfoFix = async () => await apiSQL.get("/SalesInfoFix");

const getDataDrop = async (params) => await apiSQL.post("/getDataDrop", params);

const executeStoredProcedure = async (params) =>
  await apiSQL.post("/executeStoredProcedure", params, {
    responseType: "blob",
  });

const getDataDropDEV = async (params) =>
  await apiSQL.post("/getDataDropDEV", params);

const sqlUpdate = async () => await apiSQL.get("/sqlUpdate");

const fetchTables = async (params) =>
  await apiSQL.get("/AWTech/tables", {
    params,
  });

const downloadMappingCSV = async (params) =>
  await apiSQL.get("/downloadMappingCSV", {
    params,
    responseType: "blob",
  });

const fetchColumns = async (params) =>
  await apiSQL.get("/AWTech/columns", {
    params,
  });

const fetchSampleData = async (params) =>
  await apiSQL.get("/AWTech/sample-data", {
    params,
  });

const search = async (params) => await apiSQL.post("/AWTech/search", params);

const BCtoART = async (params) =>
  await apiSQL.get("/BCTOART", {
    params,
  });

const openAI = async (params) => await apiSQL.post("/openAI", params);

const openAIallCalls = async () => await apiSQL.get("/openAI/allCalls");

const setFavorite = async (params) =>
  await apiSQL.post("/openAI/setFavorite", params);

const FreqBoughtTogetherProducts = async (data) => {
  return await apiSQL.post("/FreqBoughtTogetherProducts", data);
};

const GetCustomerOrderChartData = async (klantnr) => {
  return await apiSQL.get("/GetCustomerOrderChartData", {
    params: { KLANR: klantnr },
  });
};

const getArtArtmagBase = async (params) =>
  await apiSQL.get(
    "/artArtmagBase",
    params && Object.keys(params).length ? { params } : undefined
  );

const getHartDashboardBase = async () => await apiSQL.get("/hartDashboardBase");

const refreshHartDashboardBase = async (params) =>
  await apiSQL.post("/hartDashboardBase/refresh", params);

const refreshArtArtmagBase = async () =>
  await apiSQL.post("/artArtmagBase/refresh");

const getArtArtmagBaseRefreshJob = async (jobId) =>
  await apiSQL.get(`/artArtmagBase/refresh/${jobId}`);

const freezeArtArtmagBase = async (params) =>
  await apiSQL.post("/artArtmagBase/freeze", params);

const getArtArtmagBaseSnapshots = async () =>
  await apiSQL.get("/artArtmagBase/snapshots");

const getIgnoredArtArtmagBase = async () =>
  await apiSQL.get("/artArtmagBase/ignored");

const ignoreArtArtmagBaseBulk = async (params) =>
  await apiSQL.post("/artArtmagBase/ignored/bulk", params);

const deleteIgnoredArtArtmagBase = async (id) =>
  await apiSQL.delete(`/artArtmagBase/ignored/${id}`);

const getArtArtmagBaseHistoryChart = async (params) =>
  await apiSQL.get("/artArtmagBase/history-chart", { params });

const rebuildArtArtmagBaseHistory = async () =>
  await apiSQL.post("/artArtmagBase/history/rebuild");

const getArtArtmagBaseHistoryRebuildJob = async (jobId) =>
  await apiSQL.get(`/artArtmagBase/history/rebuild/${jobId}`);

const getArtArtmagBaseHistoryResolveDrillPath = async (params) =>
  await apiSQL.get("/artArtmagBase/history-resolve-drill-path", { params });

const getArtArtmagBaseHistoryHartActions = async (params) =>
  await apiSQL.get("/artArtmagBase/history-hart-actions", { params });

const getArtArtmagBaseHistoryDiffTree = async (params) =>
  await apiSQL.get("/artArtmagBase/history-diff-tree", { params });

const updateMarginCalculations = async () =>
  await apiSQL.get("/updateMarginCalculations");

const getRepairCustomerSummary = async (params) =>
  await apiSQL.get("/repairCustomerSummary", { params });

const refreshRepairCustomerSummary = async (params) =>
  await apiSQL.post("/repairCustomerSummary/refresh", params);

const curateRepairCustomerSummary = async (params) =>
  await apiSQL.post("/repairCustomerSummary/curate", params);

const addRepairCustomerSummaryRemark = async (params) =>
  await apiSQL.post("/repairCustomerSummary/remark", params);

const sqlService = {
  updateMarginCalculations,
  getRepairCustomerSummary,
  refreshRepairCustomerSummary,
  curateRepairCustomerSummary,
  addRepairCustomerSummaryRemark,
  GetCustomerOrderChartData,
  GetOrdersByCustomer,
  SalesInfoFix,
  getDataDrop,
  executeStoredProcedure,
  getDataDropDEV,
  sqlUpdate,
  MOFdata,
  Paymentsdata,
  LopendeLVB,
  OpenstaandeDoc,
  OpenstaandeDocSuppliers,
  AllFinanceDocsCustomers,
  AllFinanceDocsSuppliers,
  LopendeVKO,
  LopendeHRB,
  updateLopendeVKO,
  updateLopendeLVB,
  updateLopendeHRB,
  updateOpenstaandeDoc,
  updateOpenstaandeDocSuppliers,
  updateAllFinanceDocsCustomers,
  updateAllFinanceDocsSuppliers,
  historiekKlantArt,
  handleTags,
  AddManualTag,
  GetSalesData,
  getMarginByMerkPerVert,
  updateSalesData,
  fetchTables,
  fetchColumns,
  fetchSampleData,
  search,
  openAI,
  openAIallCalls,
  setFavorite,
  downloadMappingCSV,
  monthSalesInfo,
  BCtoART,
  FreqBoughtTogetherProducts,
  LopendeMOF,
  LopendeHRF,
  getArtArtmagBase,
  getHartDashboardBase,
  refreshHartDashboardBase,
  refreshArtArtmagBase,
  getArtArtmagBaseRefreshJob,
  freezeArtArtmagBase,
  getArtArtmagBaseSnapshots,
  getIgnoredArtArtmagBase,
  ignoreArtArtmagBaseBulk,
  deleteIgnoredArtArtmagBase,
  getArtArtmagBaseHistoryChart,
  getArtArtmagBaseHistoryDiffTree,
  getArtArtmagBaseHistoryHartActions,
  getArtArtmagBaseHistoryResolveDrillPath,
  rebuildArtArtmagBaseHistory,
  getArtArtmagBaseHistoryRebuildJob,
};

export default sqlService;
